import dayjs from 'dayjs';
import type { OptionType } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';

// extend locale
import 'dayjs/locale/es';

// extends plugins
dayjs.extend(localeData);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);

// Esta funcion es para poder usar dayjs con el locale en español
// Si importas y utilizas dayjs directamente, no estara en español.
const datejs = (
  date?: string | Date,
  format?: OptionType,
  locale?: string,
  strict?: boolean
) => {
  return dayjs(date, format, locale, strict).locale('es');
};

export const createDateFromYear = (year: number) => {
  // Create a new Dayjs object by passing the year, month, and day as arguments
  return datejs(`${year}-01-01`);
};

export const getMonthsOfYear = () => {
  const months = Array.from({ length: 12 }, (_, index) => {
    const month = datejs().month(index);
    return month.format('MMMM');
  });

  return months;
};

export { datejs };
